// extracted by mini-css-extract-plugin
export default {"wrapper":"Place_wrapper__TrTyc","card":"Place_card__TOKjB","row":"Place_row__hpsEZ","location":"Place_location__QJxJN"};